export default __webpack_public_path__ + "static/media/Goin_ First.81cdacc2.png";